module.exports = __webpack_public_path__ + "img/15.31181fe0.jpg";